/**
 * Highlights the active menu item in the mobile navigation drawer.
 *
 * This mirrors the existing "list-menu__item--active" / aria-current="page"
 * styling already used for submenu links, but applies it via JS so the
 * (large) header.liquid section doesn't need to be edited directly.
 */
document.addEventListener('DOMContentLoaded', function () {
  var currentPath = window.location.pathname.replace(/\/+$/, '') || '/';

  document.querySelectorAll('.menu-drawer__menu-item').forEach(function (item) {
    if (item.tagName !== 'A') return;

    var href = item.getAttribute('href');
    if (!href) return;

    var itemPath;
    try {
      itemPath = new URL(href, window.location.origin).pathname.replace(/\/+$/, '') || '/';
    } catch (e) {
      return;
    }

    if (itemPath === currentPath) {
      item.classList.add('list-menu__item--active');
      item.setAttribute('aria-current', 'page');

      // If this link is nested inside a collapsible <details> section,
      // also highlight the parent summary so the active group is visible.
      var details = item.closest('details');
      if (details) {
        var summary = details.querySelector('summary.menu-drawer__menu-item');
        if (summary) {
          summary.classList.add('list-menu__item--active');
        }
      }
    }
  });
});
